import { useAuth } from '@/contexts/AuthContext';
import AdminLayout from './AdminLayout';
import SalesLayout from './SalesLayout';

/**
 * RoleBasedLayout - Switches layout based on user role
 *
 * Admin users get the sidebar navigation layout
 * Sales staff get the mobile-optimized layout
 */
export default function RoleBasedLayout() {
  const { isAdmin } = useAuth();

  if (isAdmin) {
    return <AdminLayout />;
  }

  return <SalesLayout />;
}
